import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box
} from "@mui/material";

export default function ReportPreview({ open, onClose, template }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>HTML Preview</DialogTitle>

      <DialogContent dividers>
        <Box
          sx={{
            position: "relative",
            width: template.page.width,
            height: template.page.height,
            bgcolor: "white",
            mx: "auto",
            boxShadow: 2
          }}
        >
          {template.elements.map(element => (
            <Box
              key={element.id}
              sx={{
                position: "absolute",
                left: element.x,
                top: element.y,
                width: element.width,
                height: element.height,
                fontSize: element.style?.fontSize || 12,
                fontWeight: element.style?.bold ? "bold" : "normal"
              }}
            >
              {element.type === "field"
                ? `{${element.field}}`
                : element.text}
            </Box>
          ))}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}